import React from 'react';

export function NoBeneficiariesDisplay() {
  return (
    <div className="no-beneficiaries-display">
      <span className="material-symbols-outlined">group</span>
      <h3>No beneficiaries selected</h3>
      <p>Add beneficiaries to specify how this assset should be distributed.</p>
    </div>
  );
}
